import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import { AdCampaignTypeEnum } from '@entities/media';

export const AD_TYPE_HINT_TITLES = {
  [AdCampaignTypeEnum.Interval]: TEXTS.AD_TYPE_INTERVAL_QUESTION,
  [AdCampaignTypeEnum.ExactTime]: TEXTS.AD_TYPE_EXACT_QUESTION,
  [AdCampaignTypeEnum.Period]: 'Как работает вещание с повторами?',
  [AdCampaignTypeEnum.Instant]: 'Как работает вещание моментального ролика?',
};
